interface I_StatusProps {
  label: string;
  color: string;
  value: string;
}

export type T_UserStatus =
  | "active"
  | "pending"
  | "suspended"
  | "inactive"
  | "error";

export const C_USER_STATUS: { [key: string]: I_StatusProps } = {
  ACTIVE: {
    label: "Activo",
    color: "#388e3c",
    value: "active"
  },
  PENDING: {
    label: "Pendiente",
    color: "#0288d1",
    value: "pending"
  },
  SUSPENDED: {
    label: "Suspendido",
    color: "#757575",
    value: "suspended"
  },
  INACTIVE: {
    label: "Inactivo",
    color: "#e64a19",
    value: "inactive"
  },
  ERROR: {
    label: "Error",
    color: "#f44336",
    value: "error"
  }
};

export const O_USER_STATUS: { [key: string]: I_StatusProps } = {
  [C_USER_STATUS.ACTIVE.value]: C_USER_STATUS.ACTIVE,
  [C_USER_STATUS.ACTIVE.label]: C_USER_STATUS.ACTIVE,
  [C_USER_STATUS.PENDING.value]: C_USER_STATUS.PENDING,
  [C_USER_STATUS.PENDING.label]: C_USER_STATUS.PENDING,
  [C_USER_STATUS.SUSPENDED.value]: C_USER_STATUS.SUSPENDED,
  [C_USER_STATUS.SUSPENDED.label]: C_USER_STATUS.SUSPENDED,
  [C_USER_STATUS.INACTIVE.value]: C_USER_STATUS.INACTIVE,
  [C_USER_STATUS.INACTIVE.label]: C_USER_STATUS.INACTIVE,
  [C_USER_STATUS.ERROR.value]: C_USER_STATUS.ERROR,
  [C_USER_STATUS.ERROR.label]: C_USER_STATUS.ERROR
};

export const STATUS_USER_ARRAY = [
  C_USER_STATUS.ACTIVE,
  C_USER_STATUS.PENDING,
  C_USER_STATUS.SUSPENDED,
  C_USER_STATUS.INACTIVE
];
